// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__AE9lk","container":"Profile_container__BVoU6","header":"Profile_header__aKzBF","action":"Profile_action__c48kU","content":"Profile_content__QbCOE"};